import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

/**
 * @name replace-all
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTRhMSAxIDAgMCAxIDEgMXY1YTEgMSAwIDAgMS0xIDEiIC8+CiAgPHBhdGggZD0iTTE0IDRhMSAxIDAgMCAxIDEtMSIgLz4KICA8cGF0aCBkPSJNMTUgMTBhMSAxIDAgMCAxLTEtMSIgLz4KICA8cGF0aCBkPSJNMTkgMTRhMSAxIDAgMCAxIDEgMXY1YTEgMSAwIDAgMS0xIDEiIC8+CiAgPHBhdGggZD0iTTIxIDRhMSAxIDAgMCAwLTEtMSIgLz4KICA8cGF0aCBkPSJNMjEgOWExIDEgMCAwIDEtMSAxIiAvPgogIDxwYXRoIGQ9Im0zIDcgMyAzIDMtMyIgLz4KICA8cGF0aCBkPSJNNiAxMFY1YTIgMiAwIDAgMSAyLTJoMiIgLz4KICA8cmVjdCB4PSIzIiB5PSIxNCIgd2lkdGg9IjciIGhlaWdodD0iNyIgcng9IjEiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/replace-all
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const ReplaceAll: IconNode = [
  ['path', { d: 'M14 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1' }],
  ['path', { d: 'M14 4a1 1 0 0 1 1-1' }],
  ['path', { d: 'M15 10a1 1 0 0 1-1-1' }],
  ['path', { d: 'M19 14a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1' }],
  ['path', { d: 'M21 4a1 1 0 0 0-1-1' }],
  ['path', { d: 'M21 9a1 1 0 0 1-1 1' }],
  ['path', { d: 'm3 7 3 3 3-3' }],
  ['path', { d: 'M6 10V5a2 2 0 0 1 2-2h2' }],
  ['rect', { x: '3', y: '14', width: '7', height: '7', rx: '1' }],
];

export default ReplaceAll;
